import React, { useEffect } from "react";
import { Input, InputProps } from "reactstrap";
import { useTranslation } from "react-i18next";

import { SelectListDto } from "../../models";
import { useGetCitySelectListQuery } from "../../store/api/cityApi";
import { toast } from "react-toastify";

type TProps = InputProps & {
  placeholder: string;
  governorateId: string;
};

export const CitySelect: React.FC<TProps> = ({
  governorateId,
  placeholder,
  ...props
}) => {
  const { t, i18n } = useTranslation();

  const { data, isLoading, error } = useGetCitySelectListQuery(governorateId, {
    skip: !governorateId,
  });

  useEffect(() => {
    if (error) {
      const errMsg = 'status' in error ? (error.data as any)?.message || 'An error occurred' : 'An error occurred';
      toast.error(errMsg, {
        autoClose: 3000,
      });
    }
  }, [error]);

  return (
    <div className="input-group">
      <Input {...props}>
        <option value={""}>{t(placeholder)} </option>
        {data &&
          data.length &&
          data.map(({ id, value }: SelectListDto) => (
            <option value={id} key={id} className="text-capitalize">
              {i18n.language === "ar" ? value.ar : value.en}
            </option>
          ))}
      </Input>
    </div>
  );
};
